import * as types from './actionTypes'

export const resetPublicForms = () => ({
    type: types.PUBLIC_FORMS_RESET
})

export const createPublicForm = (data, notifications) => ({
    type: types.PUBLIC_FORM_CREATE,
    data,
    notifications
})

export const createPublicFormSuccess = () => ({
    type: types.PUBLIC_FORM_CREATE_SUCCESS
})

export const createPublicFormFailed = () => ({
    type: types.PUBLIC_FORM_CREATE_FAILED
})

export const deletePublicForm = (form) => ({
    type: types.PUBLIC_FORM_DELETE,
    form
})

export const deletePublicFormSuccess = () => ({
    type: types.PUBLIC_FORM_DELETE_SUCCESS
})

export const deletePublicFormFailed = () => ({
    type: types.PUBLIC_FORM_DELETE_FAILED
})

export const updatePublicForm = (data, notifications) => ({
    type: types.PUBLIC_FORM_UPDATE,
    data,
    notifications
})

export const updatePublicFormSuccess = () => ({
    type: types.PUBLIC_FORM_UPDATE_SUCCESS
})

export const updatePublicFormFailed = () => ({
    type: types.PUBLIC_FORM_UPDATE_FAILED
})

export const getNotifications = (formId) => ({
    type: types.NOTIFICATIONS_FETCH,
    formId
})

export const getNotificationsSuccess = (notifications) => ({
    type: types.NOTIFICATIONS_FETCH_SUCCESS,
    notifications
})

export const getNotificationsFailed = () => ({
    type: types.NOTIFICATIONS_FETCH_FAILED
})

export const clonePublicForm = (form) => ({
    type: types.PUBLIC_FORM_CLONE,
    form
})

export const clonePublicFormSuccess = (duplicate) => ({
    type: types.PUBLIC_FORM_CLONE_SUCCESS,
    duplicate
})

export const clonePublicFormFailed = () => ({
    type: types.PUBLIC_FORM_CLONE_FAILED
})

export const setPublicFormTemplatesOrder = (entity, order) => ({
    type: types.SET_PUBLIC_FORM_TEMPLATES_ORDER,
    entity,
    order
})
